const styles = {
  root: {
    minHeight: 50,
  },
  swiperContainer: {
    '& .swiper': {
      px: { xs: 0, sm: 1 },
      minWidth: '100%',
    },
    '& .swiper-button-next': {
      pl: 0,
      right: 0,
      padding: '20px',
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
      backgroundColor: '#fff',
    },
    '& .swiper-button-prev': {
      pr: 0,
      left: 0,
      padding: '20px',
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
      backgroundColor: '#fff',
    },
    '& .swiper-slide': {
      width: { sm: 'auto!important' },
    },
  },

  bodyTypesTitle: {
    marginBottom: 1,
  },
}

export default styles
